import { render } from "./TinyPumperHealthReportTotals.vue?vue&type=template&id=08e93f1e"
import script from "./TinyPumperHealthReportTotals.vue?vue&type=script&lang=js"
export * from "./TinyPumperHealthReportTotals.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__